module.exports = __webpack_public_path__ + "static/media/Inventor Dark Theme UI.4cc13e1e.png";